/**
 * @author Ariel
 * @description 经销商管理
 * @Date 2020/1/10
 */
import React from "react";
import {connect} from "dva";
import {templateConfig,reduxTemplateConfig} from "./config";
import {component_tool,framework_tool} from '../../../tool';
let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport} = component_tool

class DealerManager extends WizContainer {
  componentName = 'dealerManager';

  constructor(props) {
    super(props);
    this.state={
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '经销商名称',
        field: 'name',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '经销商简称',
        field: 'shortName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '销售代码',
        field: 'preSalesNumber',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '售后代码',
        field: 'afterSalesNumber',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '站点类型',
        field: 'type',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '单一销售展厅类型区分',
        field: 'nevTypeStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织',
        field: 'orgName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '省份',
        field: 'province',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '开店状态',
        field: 'state',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '开店时间',
        field: 'openTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '在职人数',
        field: 'onJobNumber',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }

    ]

    let dict = [
      { code: 1, codeName: '4S网点' },
      { code: 2, codeName: '直营店' },
      { code: 3, codeName: '单一售后' },
      { code: 4, codeName: '单一销售' },
      { code: 5, codeName: '卫星店/直营店' },
      { code: 6, codeName: '自修站' },
      { code: 7, codeName: '卫星店' },
      { code: 8, codeName: '精品店' },
      { code: 9, codeName: 'dealer' },
      { code: 10, codeName: '4S店' },
      { code: 11, codeName: '汽车零售' },
      { code: 12, codeName: '单一销售展厅' },
      { code: 13, codeName: 'NEV单一售后' },
      { code: 14, codeName: '轻量化4S网点' },
      { code: 15, codeName: 'NEV专区' },
      { code: 16, codeName: '商超店' },
      { code: 17, codeName: '自修店' },
      { code: 18, codeName: '二级网点' },
      { code: 19, codeName: '车工坊C1' },
      { code: 20, codeName: '车工坊C2' },
      { code: 21, codeName: '车工坊B' },
      { code: 22, codeName: '德科品牌授权经销商' },
      { code: 99, codeName: '暂定' },
      { code: 0, codeName: '无' }
    ]


    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        let {brandName,areaName} = e
        if(brandName && brandName.length) {
          e.orgName = brandName
          if (areaName && areaName.length) {
            e.orgName = brandName + '>' + areaName
          }
        } else if (areaName && areaName.length) {
          e.orgName = areaName
        }
        e.state === 2 ? e.state = '建设中' : e.state === 1 ?  e.state = '已开店' :  e.state = '已关店'
        dict.forEach(element=>{
          if(e.type==element.code){
            e.type = element.codeName
          }
        })

      })
      WizBrowserExport({
        title: '经销商信息',
        sheetName: '经销商信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '经销商信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({jumpPage:this.jumpPage}),
      apiDataFormat: {
        delete: this._handleCMD,
        export: this._handleFile
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(DealerManager);
